export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="bg-white py-28 md:py-40 border-t border-[#E5EBF2]"
    >
      <div className="container-ags">
        <div className="grid md:grid-cols-12 gap-10 md:gap-16">
          <div className="md:col-span-4">
            <span className="font-mono text-[11px] uppercase tracking-[0.22em] text-[#0E2A57]/60 font-medium">
              01 — About Us
            </span>
            <h2 className="mt-6 font-heading font-extrabold text-4xl md:text-5xl lg:text-6xl leading-[1.0] tracking-[-0.035em] text-[#050B14]">
              A modern, family-owned partner — <span className="italic-display font-normal text-[#0E2A57]">not a faceless subcontractor.</span>
            </h2>
          </div>

          <div className="md:col-span-7 md:col-start-6 space-y-6 text-[#475569] text-lg md:text-2xl leading-[1.55]">
            <p data-testid="about-paragraph-1">
              We provide reliable, flexible, and professional cleaning services
              tailored to the needs of each client. Whether it's an office,
              warehouse, factory, retail unit, school, or healthcare facility,
              our goal is to deliver consistent quality and dependable service.
            </p>
            <p data-testid="about-paragraph-2">
              For our Irish corporate clients, we are not just a subcontractor —
              we are a stable, long-term partner dedicated to keeping your
              premises pristine and professional, every single day.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
